/**
 * loadFile
 *
 * @description Display network file loading progress
 *
 * @param {String} url - loadFile url
 * @param {Function} onsuccess - loadFile onsuccess callback
 * @param {Function} onerror - loadFile onerror callback
 * @param {Function} onprogress - loadFile onprogress callback
 * @return {Promise}
 *
 * @since 1.0.0
 *
 * @example
 */
export async function loadFile(url, onsuccess, onerror, onprogress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    let notifiedNotComputable = false;

    xhr.open("GET", url, true);
    xhr.responseType = "arraybuffer";

    xhr.onprogress = function(ev) {
      if (ev.lengthComputable) {
        onprogress && onprogress(parseInt((ev.loaded / ev.total) * 100));
      } else {
        if (!notifiedNotComputable) {
          notifiedNotComputable = true;
          onprogress && onprogress(-1);
        }
      }
    };

    xhr.onloadend = function() {
      if (xhr.status.toString() && !xhr.status.toString().match(/^2/)) {
        onerror && onerror(xhr);
        reject(xhr);
      } else {
        if (!notifiedNotComputable) {
          onprogress && onprogress(100);
        }

        const options = {};
        const headers = xhr.getAllResponseHeaders();
        const m = headers.match(/^Content-Type\:\s*(.*?)$/im);

        if (m && m[1]) {
          options.type = m[1];
        }

        const blob = new Blob([this.response], options);
        const blobUrl = window.URL.createObjectURL(blob);
        onsuccess && onsuccess(blobUrl, headers);
        resolve(blobUrl, headers);
      }
    };

    xhr.send();
  });
}
export async function loadImgXHR(url, onsuccess, onerror, onprogress) {
  return new Promise((resolve, reject) => {
    loadFile(url, onsuccess, onerror, ratio => {
      if (ratio == -1) {
        // Ratio not computable. Let's make this bar an undefined one.
        // Remember that since ratio isn't computable, calling this function
        // makes no further sense, so it won't be called again.
      } else {
        // We have progress ratio; update the bar.
      }
      onprogress && onprogress(ratio);
    })
      .then((url, headers) => {
        // Loading successfuly complete; set the image and probably do other stuff.
        //  onsuccess && onsuccess(url, headers);
        resolve(url, headers);
      })
      .catch(xhr => {
        // An error occured. We have the XHR object to see what happened.
        const e = new ErrorEvent("ImageLoadFail", {
          bubbles: true,
          cancelable: false,
          error: xhr,
          message: "图片加载失败"
        });
        onerror && onerror(e);
        reject(e);
      });
  });
}
export async function loadImage(url, onsuccess, onerror) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = url;
    if (img.complete) {
      const tempDest = {
        url,
        width: img.width,
        height: img.height
      };
      onsuccess && onsuccess(url, img.width, img.height);
      resolve(tempDest);
    } else {
      img.onload = function() {
        const tempDest = {
          url,
          width: img.width,
          height: img.height
        };
        onsuccess && onsuccess(url, img.width, img.height);
        img.onload = null;
        resolve(tempDest);
      };
    }
    img.onerror = function(e) {
      onerror && onerror(e);
      reject(e);
    };
  });
}
